// ./store/index.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

var state = {
  Tabselect: 'N',
  playername: '',
  loading: false,
  suggestionList: [],
  result: undefined,
  users: [],
  record: {
    G: '',
    AB: '',
    R: '',
    H: '',
    SEC: '',
    THI: '',
    HR: '',
    RBI: '',
    BB: '',
    SO: '',
    SB: '',
    CS: '',
    AVG: '',
    SLG: '',
    OPS: '',
    GS: '',
    CG: '',
    ShO: '',
    W: '',
    L: '',
    IPa: '',
    IPb: '',
    ER: '',
    ERA: '',
    WR: '',
    HBP: '',
    TBF: '',
    age: '',
    hand: '',
    heig: '',
    weig: ''

  },
  result_players: [],
  selectedPoss: [],
  inputedPoss: {},
  targetPos: true,
  targetMatchName: false,
  list: [
    { id: 'btotal', title: '野手通算' },
    { id: 'ptotal', title: '投手通算' },
    { id: 'byear', title: '野手年度' },
    { id: 'pyear', title: '投手年度' }
  ],
  blank: { id: 'blank', title: '' }
}

const actions = {
  done ({ state, commit }) {
    // state.routeでアクセス可能
    console.log('actions:', state.route.params.id)
    commit('done')
  },
  setValue (context, {vals, keyname}) {
    context.commit('updateValue', {vals, keyname})
  }
}

const mutations = {
  done (state) {
    // state.routeでアクセス可能
    console.log('mutations:', state.route.params.id)
  },
  updateValue (state, { vals, keyname }) {
    state[keyname] = vals
  },
  updateArrays (state, { vals, array, index }) {
    state[array][index] = vals
  },
  setLoading (state, payload) {
    state.loading = payload
  }
}

const getters = {
  list: state => state.list,
  detail: state => {
    // state.routeでアクセス可能
    return state.list.find(l => l.id.toString() === state.route.params.id.toString()) || {}
  }
}
export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js